(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Hashids", [], factory);
	else if(typeof exports === 'object')
		exports["Hashids"] = factory();
	else
		root["Hashids"] = factory();
})(self, () => {
return 